import React from 'react';
import SignupWidgetMarkup from './SignupWidgetMarkup';
import { SignupWidgetHoc } from 'core/hoc';

const SignupWidget = props => (
	<SignupWidgetHoc source="footer_widget" {...props}>
		{passedProps => (
			<SignupWidgetMarkup {...passedProps} />
		)}
	</SignupWidgetHoc>
);

export default SignupWidget;
